export const ROOT_RENDER_ID = 'root';

export const FolderCode = {
    PARKS: 'parks',
    PLOTS: 'plots',
    PROGRAMS: 'programs',
    PROJECTS: 'projects',
    ADM_UNITS: 'admin_units',
    INFO: 'info_layers',
    F_ZONES: 'funkcionalnye_zony',
    PLAN_F_ZONES: 'funkcionalnye_zony_plan',
    GEN_PLANS: 'gen_plans',
    GEN_PLANS_OBJECTS: 'gen_plany_koordinaty',
    LANDS: 'lands',
    TOSER: 'folder42'
} as const;

export const BaseLayerCode = {
    'parks': 'ia129',
    // 'plots': 'investmap_layer_7531_copy',
    'plots': 'investmap_layer_7531_export',
    'projects': 'ia14',
    'programs': 'ia15',
    'folder41': 'layer'
} as const;


export const ComparableLayers = new Set([
    'sites_1',
    'sites_2',
    'sites_3',
    'sites_4'
]);

export const favouritesContainersCodes = [
    'plots',
    'lands',
    'sites_1',
    'sites_2',
    'sites_3',
    'sites_4',
    'parks_1',
    'parks_2',
    'parks_3',
    'projects',
    'projects_3',
    'projects_2',
    'projects_1',
    'land_for_rent'
];

export const pdfContainerCodes = [
    ...favouritesContainersCodes,
    'layer',
    'ia4',
    'ia34',
    'programs_1',
    'programs_2',
    'programs_3',
    'programs_4',
    'programs_5',
    'programs_6',
    'investment_projects',
    'investment_projects_apk'
];

export const opacityLayers = [
    'info_layers',
    'info_layers_1',
    'monogoroda_toser',
    'plan_obj_folder',
    'stp'
];

export const layersWithToc = [
    'sites_1',
    'sites_2',
    'sites_3',
    'sites_4',
    'parks_1',
    'parks_2',
    'parks_3',
    'land_for_rent'
];
